<template>
  <div v-if="detail" class="detailsWrap">
    <div class="section">
      <div class="itemimg">
        <swiper v-if="!isVideoShow" :options="swiperOptions" @change="onSlideChange" class="swiper">
          <template>
            <swiper-slide
              class="swiper-item"
              v-for="(item, index) in detail.goodPhotoList"
              :key="index"
            >
              <div class="img-box" @click="imgpreview(index)">
                <img
                  v-if="(item.resourceType == 1 && !item.isVideoShow) || item.resourceType == 0"
                  :src="item.imageUrl + '?imageView2/1'"
                  alt=""
                />

                <img
                  v-if="item.resourceType == 1 && !item.isVideoShow"
                  @click.stop="palyVideo(index)"
                  class="videoIconplay"
                  src="https://img.zai-art.com/zaiart/saas/image/md/d6818b0c12db59beb41907171e3104ad.png"
                  alt=""
                />
              </div>
            </swiper-slide>
          </template>

          <div class="swiper-pagination" v-if="!isVideoShow" slot="pagination"></div>
        </swiper>
        <div v-else class="img-box">
          <video
            id="myvideo"
            class="video"
            controls="controls"
            autoplay="autoplay"
            @ended="endVideo()"
            @error="endVideo()"
            @pause="endVideo()"
            controlsList="nodownload"
          >
            <source :src="resourceUrl" type="video/mp4" />
          </video>
        </div>
        <subject v-if="detail.detail" :content="detail.detail"></subject>
      </div>
      <div class="iteminfo">
        <div class="name">{{ detail.name }}</div>
        <div v-if="detail.subject" class="desc">{{ detail.subject }}</div>
        <sku :data="detail"></sku>
        <a v-if='false' :href="'tel:' + phone" class="btn"><a>购买咨询</a></a>
      </div>
    </div>
  </div>
</template>

<script>
import { getShopGoodsView } from '@/api/index';
import { ImagePreview } from 'vant';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import Subject from './common/subject.vue';
import Sku from './common/sku.vue';
export default {
  components: {
    swiper,
    swiperSlide,
    Subject,
    Sku,
  },
  data() {
    return {
      pid: null,
      detail: null,
      phone: null,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination', //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        on: {
          // slideChange(swiper) {
          //   self.isVideoShow = false;
          // },
        },
      },
      isVideoShow: false,
      resourceUrl: null,
    };
  },
  created() {
    // self = this;
    this.pid = this.$route.params.id;
    this.phone = window.bldewbPhone;
    this.init();
  },
  methods: {
    onSlideChange(index) {
      console.log(index);
    },
    init() {
      getShopGoodsView({ id: this.pid }).then(res => {
        this.detail = res.data;
      });
    },
    imgpreview(index) {
      let arr = [];
      this.detail.goodPhotoList.map(item => {
        arr.push(item.imageUrl + '?imageView2/1');
      });
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    palyVideo(index) {
      this.resourceUrl = this.detail.goodPhotoList[index].resourceUrl;
      this.isVideoShow = true;
    },
    endVideo(index) {
      this.isVideoShow = false;
    },
  },
};
</script>
<style>
.swiper .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
}
.swiper .swiper-pagination-bullet-active {
  background: #333;
  border: 1px solid #fff;
}
</style>
<style lang="less" scoped>
.detailsWrap {
  padding: 20px 40px;
  min-height: 100vh;
  background: #fff;
  .section {
    display: flex;

    .itemimg {
      // width: 642px;
      width: 57.73%;
      // height: 642px;
      background: #f1f1f1;
      margin-right: 20px;
      .swiper,
      .swiper img {
        display: block;
        width: 100%;
        height: 642px;
      }
      .swiper img {
        object-fit: contain;
      }
      .img-box {
        position: relative;
        .videoIconplay {
          display: block;
          width: 100px;
          height: 100px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .video {
          width: 100%;
          height: 642px;
        }
      }
    }
    .iteminfo {
      flex: 1;
      // min-width: 370px;
      height: 506px;
      background: #f1f1f1;
      padding: 20px 30px;
      position: sticky;
      top: 20px;
      .name {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 40px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 6px;
      }
      .desc {
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #999999;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 20px;
      }
      .btn {
        display: block;
        width: 100%;
        height: 60px;
        margin: 0 auto;
        background: #222222;
        border-radius: 2px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-top: 40px;
      }
    }
  }
}
</style>
